var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorMessage)?_c('div',{staticClass:"flex justify-center p-32"},[_c('p',{staticClass:"max-w-lg text-center text-vueCharcoal-500",domProps:{"textContent":_vm._s(_vm.errorMessage)}})]):_c('div',{ref:"container"})}
var staticRenderFns = []

export { render, staticRenderFns }